import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    selected: PropTypes.bool
};
const ListItem = createComponent({
    displayName: 'ListItem',
    root: 'li',
    propTypes,
    propConfig: {
        classNames (props) {
            return props.selected ? [
                'swan-list-item-selected'
            ] : [];
        }
    }
});

export { ListItem };
